export function getComponentByProperty(components, property, value) {
    for (const component of components) {
        if (component[property] === value) {
            return component;
        }
        if (component.children) {
            const found = getComponentByProperty(component.children, property, value);
            if (found) {
                return found;
            }
        }
    }
    return null;
}

export const allowedComponentTypes = {
    "Link Record": ["Table"],
    "Split View": ["Content", "Split View"],
    "Gantt Chart": ["Content", "Gantt Chart", "Heading"],
    "Table": ["Content", "Table", "Heading"],
    "Kanban": ["Content", "Heading", "Kanban"],
    "Search": ["Table"],
    "Calendar": ["Content", "Calendar", "Heading"],
    "Cards": ["Content", "Heading", "Cards"],
    "List": ["Content", "Heading", "List"],
    "Single Record": [
        "Stacked Section",
        "Split Section",
        "Tab Container",
        "Tab",
        "Content",
        "Heading",
        "Summary",
        "View",
        "Reference",
        "Progress Bar",
        "History",
        "Discussion",
    ],
    "New Record": ["Content", "Form"],
    "Edit Record": ["Content", "Form"],
}